<div class="request-list-container">
  <div class="content">
    @if (errorMessage()) {
      <div class="error-banner" role="alert">
        <span>{{ errorMessage() }}</span>
        <div class="error-actions">
          <button class="error-retry-button" (click)="retryLoad()">Retry</button>
          <button class="error-dismiss" (click)="dismissError()" aria-label="Dismiss error">×</button>
        </div>
      </div>
    }
    <div class="request-cards">
      @if (dataLoading()) {
        <app-loading-animation></app-loading-animation>
      }
      @if (dataEmpty()) {
        <div class="no-data">{{noRequestsMessage()}}</div>
      }
      @if (dataAvailable()) {
        @for (request of requests(); track request.id) {
          <div class="request-card-wrapper">
            <div class="request-card">
              <div class="request-card-title">{{request.description}}</div>
              <div class="request-progress-text">
                @if (!request.readonly) {
                  <div>{{request.percentageComplete}}% Complete</div>
                }
                @if (request.readonly) {
                  <div>Completed</div>
                }
              </div>
              <button type="button" class="request-card-button"
                 (click)="openRequest(request)"
                 [attr.aria-label]="request.detailsLabel + ' ' + request.description">
                {{request.detailsLabel}}
              </button>
              <button type="button" class="request-card-icon"
                 (click)="openRequest(request)"
                 [attr.aria-label]="request.detailsLabel + ' ' + request.description">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true">
                  <g>
                    <path
                      d="M82.4,48.9C82.4,48.9,82.4,48.9,82.4,48.9l-15-14.8c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1l12.4,12.3H18.6   c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h59.1L65.3,63.8c-0.6,0.6-0.6,1.5,0,2.1c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.8-0.1,1.1-0.4   l15-14.8c0,0,0,0,0,0l1.1-1.1L82.4,48.9z"/>
                    </g>
                  </svg>
              </button>
                <div class="request-progress-bar-and-cancel">
                  <span class="bar">
                    <div class="bar-inner"
                    [class.completed]="request.readonly" [style.width.%]="request.percentageComplete"></div>
                  </span>
                  @if (!request.readonly) {
                    <button type="button" class="cancel-button"
                       (click)="cancelRequest(request.id)"
                       [attr.aria-label]="'Cancel ' + request.description">Cancel</button>
                  }
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
